//src/services/adminMessages.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminMessages = () => adminApiRequest("/admin/messages");

export const getAdminMessageThread = (id) =>
  adminApiRequest(`/admin/messages/${id}`);

export const adminReplyToMessage = (id, body) =>
  adminApiRequest(`/admin/messages/${id}/reply`, {
    method: "POST",
    body: JSON.stringify({ body }),
  });

export const adminUpdateMessageStatus = (id, status) =>
  adminApiRequest(`/admin/messages/${id}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });

  export const deleteAdminMessage = (id) =>
  adminApiRequest(`/admin/messages/${id}`, {
    method: "DELETE",
  });
